'use client'
import Section from 'components/Section'
import { useMemoizedContentGetter } from 'utils/contentful'
import { Box, AchieveTheme } from '@achieve/ascend'
import { Typography } from 'components/Contentful'
import { useEffect, useState } from 'react'
import { ThreeProductCard } from 'components/ThreeProductCard'
import useDTIDataForm from 'hooks/useDTIDataForm/useDTIDataForm'
import classNames from 'classnames'

function DTIProductCards({ content }) {
  const [dtiDataForm] = useDTIDataForm()
  const { title, subtitle, grid } = useMemoizedContentGetter(content, ['title', 'subtitle', 'grid'])
  const [listItemsRender, setListItemsRender] = useState([])
  const publishedCards = (listItemsRender || []).filter((item) => Boolean(item))

  useEffect(() => {
    // DTICalculator stores { dtiResult, debtAssessmentResult }; product_rank comes in the DTI response
    const productRank =
      dtiDataForm?.dataDti?.dtiResult?.product_rank ?? dtiDataForm?.dataDti?.product_rank
    if (productRank?.length) {
      const itemsRes = productRank.map((item) => item.product)
      const itemsDefaultPosition = ['APL', 'ADR', 'AHL']
      const list = []
      for (let i = 0; i < itemsRes.length; i++) {
        const element = itemsRes[i]
        list.push(grid.gridItemsCollection.items[itemsDefaultPosition.indexOf(element)])
      }
      setListItemsRender(list)
    } else {
      setListItemsRender(grid.gridItemsCollection.items)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dtiDataForm])

  return (
    <Section
      backgroundColor={AchieveTheme?.ascend?.colors?.neutral[25]}
      className={'px-0 py-12 md:px-8 md:py-12'}
      data-testid="DTIProductCards_section"
    >
      <Box display={'flex'} gap={2} flexDirection={'column'}>
        <Typography
          content={title?.textContent}
          className={'displayMd lg:displayLg font-bold! text-center'}
        />
        <Typography
          content={subtitle?.textContent}
          className={classNames('mb-10', 'bodySm lg:displaySm font-medium text-center')}
          data-testid="DTIProductCards_subtitle"
        />
        <ThreeProductCard className={'p-0'} content={{ gridItems: publishedCards }} />
      </Box>
    </Section>
  )
}
export { DTIProductCards }
export default DTIProductCards
